import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items = [], className = "" }) {
  if (!items.length) return null;
  return (
    <nav
      aria-label="Breadcrumb"
      className={`text-[11px] tracking-[0.22em] uppercase text-lak-soft ${className}`}
    >
      <ol className="flex flex-wrap items-center justify-center md:justify-start gap-x-2 gap-y-1">
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={it.url} className="flex items-center gap-2">
              {i > 0 && <ChevronRight size={12} strokeWidth={1.25} className="text-lak-soft/60" />}
              {last ? (
                <span aria-current="page" className="text-lak-text">{it.name}</span>
              ) : (
                <Link to={it.url} className="link-underline hover:text-lak-text">{it.name}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
